export default __webpack_public_path__ + "static/media/footer3.48aa48d0.png";